import { useContext, useReducer } from "react";
import { ACTIONS, initialState, reducer } from "./pendingContractorsReducer";
import AuthContext from "../../components/context/AuthContext";
import axios from "axios";

const usePendingContractorAudits = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const authCtx = useContext(AuthContext);

  const convertPendingAuditsHandler = (data) => {
    return data?.map((option) => {
      let date = new Date(option?.AUDIT_DATE);
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      let hours = date.getHours();
      hours = ("0" + hours).slice(-2);
      let minutes = date.getMinutes();
      minutes = ("0" + minutes).slice(-2);

      let dateText = `${month}/${day}/${year} ${hours}:${minutes}`;
      return {
        value: option,
        label: `${dateText} - ${
          option.AUDITOR_FULL_NAME ? option.AUDITOR_FULL_NAME : option.AUDITOR
        }`,
      };
    });
  };

  const toggleFetchingQuestionData = () => {
    dispatch({
      type: ACTIONS.TOGGLE_FETCHING_QUESTION_DATA,
      value: initialState.selectedAudit,
    });
  };

  const setQuestionData = (data) => {
    dispatch({
      type: ACTIONS.SET_QUESTION_DATA,
      value: data,
    });
  };

  const setStatus = (text) => {
    dispatch({
      type: ACTIONS.SET_STATUS,
      value: text,
    });
  };

  const auditSelectHandler = (option) => {
    dispatch({
      type: ACTIONS.SET_SELECTED_AUDIT,
      value: option,
    });
  };

  const commentsChangeHandler = (event) => {
    dispatch({
      type: ACTIONS.SET_COMMENTS,
      value: event.target.value,
    });
  };

  const submissionResponseHandler = (response) => {
    response && response.data
      ? setStatus("Audit review submitted successfully!")
      : setStatus("Submission error: Invalid response returned.");
  };

  const togglePassFail = () => {
    dispatch({ type: ACTIONS.TOGGLE_PASS_FAIL });
  };

  const submitReviewHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.TOGGLE_LOADING });
    let url = `${process.env.REACT_APP_API_URL}/audit/submitReview`;
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    let bodyObject = {
      auditGUID: state.selectedAudit.value.AUDIT_GUID,
      reviewer: authCtx?.user?.username,
      notes: state.comments,
      passFail: state.passFail,
      email: authCtx?.user?.email,
    };
    axios
      .post(url, bodyObject, authObj)
      .then((response) => {
        submissionResponseHandler(response);
      })
      .catch((error) => {
        submissionResponseHandler(error);
      });
  };

  const resetForm = () => {
    dispatch({ type: ACTIONS.RESET_FORM });
  };

  return {
    state,
    convertPendingAuditsHandler,
    toggleFetchingQuestionData,
    setQuestionData,
    setStatus,
    auditSelectHandler,
    commentsChangeHandler,
    submitReviewHandler,
    togglePassFail,
    resetForm,
  };
};

export default usePendingContractorAudits;
